import { Injectable } from '@angular/core';

import { merge, switchMap, take, tap } from 'rxjs';

import { WebSocketEventsEnum } from '@shared/websocket';
import { AuthUser } from '@shared/signup/models';
import { AudioService as CommonAudioService } from '@tablesready/common-ui';
import {
  AuthRestaurantService,
  SocketService,
} from '@tablesready/frontend-store';
import { AuthService } from '@tablesready/frontend-auth';
import { LoggerService } from '@tablesready/frontend-logger';

@Injectable({ providedIn: 'root' })
export class AudioService extends CommonAudioService {
  private user: AuthUser = null;

  constructor(
    loggerService: LoggerService,
    private readonly socketService: SocketService,
    private readonly authService: AuthService,
    private readonly authRestaurantService: AuthRestaurantService,
  ) {
    super(loggerService);
  }

  init() {
    return this.authRestaurantService.select()
      .pipe(
        tap(user => this.user = user),
        take(1),
        switchMap(() => merge(
          this.socketService.getEventStream(WebSocketEventsEnum.InboundSmsEvent)
            .pipe(tap(() => this.inboundEvtHandler())),
          this.socketService.getEventStream(WebSocketEventsEnum.newPublicCheckInEvent)
            .pipe(tap(() => this.newPublicCheckInEvtHandler())),
        )),
      );
  }

  private inboundEvtHandler() {
    if (this.user?.location?.alertsSettings?.arrivesSmsPlayAudio) {
      this.playSMSConfirmation();
    }
  }

  private newPublicCheckInEvtHandler() {
    if (this.user?.location?.alertsSettings?.newPublicCheckInPlayAudio) {
      this.playCheckInConfirmation();
    }
  }
}
